import { render, staticRenderFns } from "./AddressSearchManual.vue?vue&type=template&id=4a9e8709&scoped=true&"
import script from "./AddressSearchManual.vue?vue&type=script&lang=js&"
export * from "./AddressSearchManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e8709",
  null
  
)

export default component.exports